// GA4 and GTM load from <head> (gatsby-ssr.js), only on the live site. This file only tracks
// SPA page views on route changes for GA4 and the FB Pixel.

// SPA route changes: fire a fresh pageview for GA4 + FB Pixel.
exports.onRouteUpdate = ({ location, prevLocation }) => {
  // The first page view is sent by gtag('config') in <head> and by the FB Pixel loader, so only
  // later in-site navigations are tracked here (otherwise the landing page counts twice).
  if (typeof window === 'undefined' || !prevLocation) return;
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
    });
  }
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'PageView');
  }
};
